import { Padding } from '@mui/icons-material';
import React, { forwardRef,useEffect } from 'react';
import Table from 'react-bootstrap/Table';
import moment from 'moment-timezone';
import '../../css/styles.css';

const VehiclePDF = forwardRef(({ details,checkList }, ref) => {

//  {console.log("checkList",checkList)}
//  {console.log("details",details)}
const generalItems = checkList.filter(item => item.category === 0 );
const vehiclePortfolioItems = checkList.filter(item => item.category === 1 );
const wheelchairRestraints = checkList.filter(item => item.category === 2 );

let answers;
try {
  if (typeof details.component === 'string') {
    const parsedOnce = JSON.parse(details.component);
    answers = typeof parsedOnce === 'string' ? JSON.parse(parsedOnce) : parsedOnce;
  } else {
    answers = details.component;
  }
} catch (err) {
  console.error('Error parsing component:', err);
  answers = [];
}// Assuming answers are part of the details object
const vehicleDetails = details.vehicleDetails;
//const parsedAnswers = answers.map(answer => JSON.parse(answer));

  const getAnswer = (questionId) => {
    const answer = answers.find((ans) => ans.questionId == questionId);
    return answer ? answer.answer : null;
  };

  return (
    <div ref={ref}>
 
      <h2 style={{textAlign:'center',padding:'26px'}}>DAILY INSPECTION REPORT</h2>
     {/*  <p>Details: {JSON.stringify(details)}</p> */}
      {/* <p>Details: {vehicleDetails}</p> */}
      <Table border={1} cellPadding={0} cellSpacing={0} style={{ width: '100%',fontSize:'20px' }}>
              <thead>
                <tr>
                  <td style={{border:"1px solid",width:"20%", fontWeight:'bold'}}>Vehicle Name:</td>
                  <td style={{border:"1px solid"}}>{vehicleDetails?.vehicle_name}</td>
                  <td style={{border:"1px solid", fontWeight:'bold'}}>Model:</td>
                  <td style={{border:"1px solid"}}>{vehicleDetails?.vehicle_model}</td>
                </tr>
                <tr>
                    <td style={{border:"1px solid", fontWeight:'bold'}}>Make:</td>
                    <td style={{border:"1px solid"}}>{vehicleDetails?.vehicle_make}</td>
                    <td style={{border:"1px solid",width:"20%", fontWeight:'bold'}}>Year:</td>
                    <td style={{border:"1px solid"}}>{vehicleDetails?.model_year}</td>
                </tr>
                <tr>
                  <td style={{border:"1px solid", fontWeight:'bold'}}>License No:</td>
                  <td style={{border:"1px solid"}}></td>
                  <td style={{border:"1px solid",width:"20%", fontWeight:'bold'}}>VIN Number:</td>
                  <td style={{border:"1px solid"}}>{vehicleDetails?.vin_no}</td>
                </tr>
                <tr>
                  <td style={{border:"1px solid", fontWeight:'bold'}}>Inspection Date:</td>
                  <td style={{border:"1px solid"}}>{ moment(details?.inspection_date, 'YYYY-MM-DD').format('MM/DD/YYYY') }</td>
                  <td style={{border:"1px solid",width:"25%" , fontWeight:'bold'}}>STS Vehicle Number:</td>
                  <td style={{border:"1px solid"}}>{vehicleDetails?.stc_vehicle_no}</td>
                </tr>
                <tr><td colspan={4} style={{border: 'none', borderLeft: 'none', borderRight: 'none', borderTop: 'none', borderBottom: 'none'}}></td></tr>
            </thead>
            <tbody>
              <tr>
                <td colspan={5} style={{Padding:'0 !important'}}>
                  <table style={{width:'100%'}}>
                    <thead  className="repeat-header">
                      <tr>
                        <th style={{border:"1px solid", fontWeight:'bold',padding:'10px',background:'#e7e1e1'}}>Components</th>
                        <th style={{border:"1px solid", fontWeight:'bold',padding:'10px',background:'#e7e1e1'}}>Good Condition</th>
                        <th style={{border:"1px solid", fontWeight:'bold',padding:'10px',background:'#e7e1e1'}}>Requires Attention</th>
                        <th style={{border:"1px solid", fontWeight:'bold',padding:'10px',background:'#e7e1e1'}}>Need Repairs</th>
                        <th style={{border:"1px solid", fontWeight:'bold',padding:'10px',background:'#e7e1e1'}}>Not Applicable</th>
                      </tr>
                    </thead>
                    <tbody>
                    {generalItems.map((item) => (
                    <tr key={item.id}>
                      <td style={{ border: "1px solid", padding:'5px'}}>{item.check_list}</td>
                      <td style={{ border: "1px solid",textAlign:'center' }}>{getAnswer(item.id) === '1' ? 'YES' : 'NO'}</td>
                      <td style={{ border: "1px solid",textAlign:'center' }}>{getAnswer(item.id) === '2' ? 'YES' : 'NO'}</td>
                      <td style={{ border: "1px solid",textAlign:'center' }}>{getAnswer(item.id) === '3' ? 'YES' : 'NO'}</td>
                      <td style={{ border: "1px solid",textAlign:'center' }}>{getAnswer(item.id) === '4' ? 'YES' : 'NO'}</td>
                    </tr>
                  ))}
                  <tr>
                    <td colspan={5} style={{fontWeight:'bold',border: "1px solid",padding:'8px'}}>Vehicle Portfolio Items </td>
                  </tr>
                  {vehiclePortfolioItems.map((item) => (
                    <tr key={item.id}>
                      <td style={{ border: "1px solid", padding:'5px'}}>{item.check_list}</td>
                      <td style={{ border: "1px solid",textAlign:'center' }}>{getAnswer(item.id) === '1' ? 'YES' : 'NO'}</td>
                      <td style={{ border: "1px solid",textAlign:'center' }}>{getAnswer(item.id) === '2' ? 'YES' : 'NO'}</td>
                      <td style={{ border: "1px solid",textAlign:'center' }}>{getAnswer(item.id) === '3' ? 'YES' : 'NO'}</td>
                      <td style={{ border: "1px solid",textAlign:'center' }}>{getAnswer(item.id) === '4' ? 'YES' : 'NO'}</td>
                    </tr>
                  ))}
                  <tr>
                    <td colspan={5} 
                        style={{fontWeight:'bold',
                                border: "1px solid",
                                borderRight: "1px solid",
                                padding:'8px'}}
                        >Lift / Wheelchair Restraints </td>
                  </tr>
                  {wheelchairRestraints.map((item) => (
                    <tr key={item.id}>
                      <td style={{ border: "1px solid", padding:'5px'}}>{item.check_list}</td>
                      <td style={{ border: "1px solid",textAlign:'center' }}>{getAnswer(item.id) === '1' ? 'YES' : 'NO'}</td>
                      <td style={{ border: "1px solid",textAlign:'center' }}>{getAnswer(item.id) === '2' ? 'YES' : 'NO'}</td>
                      <td style={{ border: "1px solid",textAlign:'center' }}>{getAnswer(item.id) === '3' ? 'YES' : 'NO'}</td>
                      <td style={{ border: "1px solid",textAlign:'center' }}>{getAnswer(item.id) === '4' ? 'YES' : 'NO'}</td>
                    </tr>
                  ))}
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
      </Table>



     
    </div>
  );
});

export default VehiclePDF;